import axios from 'axios'
import qs from 'qs';
import { async } from 'q';


const API_PREFIX = "/api/stock"
const API_PREFIX_FUND = "/api/fund"
const API_PREFIX_SECTOR = "/api/sector"

export const apiStockList = () => {
    return axios.get(`${API_PREFIX}/public/list`)
}

export const apiStockCategories = () => {
    return axios.get(`${API_PREFIX_SECTOR}/public/category`)
}

export const apiStockTrendings = () => {
    return axios.get(`${API_PREFIX}/public/trending`)
}
export const apiStockQuote = async (params) => {
    return await axios.get(`${API_PREFIX}/public/quote/${params}`)
}

export const getSummaryBySecurityID = async ({ securityID, fiscal }) => {
    return await axios.get(`${API_PREFIX}/public/summary/${securityID}`, {
        params: {
            from_fiscal: fiscal,
        }
    })
        .then(response => {
            return response
        })
        .catch(error => {
            throw error
        })
}

export const getPresentBySecurityID = async (securityID) => {
    return await axios.get(`${API_PREFIX}/public/present/${securityID}`, {
    })
        .then(response => {
            return response
        })
        .catch(error => {
            throw error
        })
}

export const apiFindShareHolder = async (securityID) => {
    return await axios.get(`${API_PREFIX}/public/shareholders/${securityID}`, {
    })
        .then(response => {
            return response
        })
        .catch(error => {
            throw error
        })
}

export const apiFindFundQuote = async (stockName) => {
    return await axios.get(`${API_PREFIX_FUND}/public/stock/${stockName}`, {
    })
        .then(response => {
            return response
        })
        .catch(error => {
            throw error
        })
}

export const apiStockNav = async ({ stockName, from, to, period = null}) => {
    let url = `${API_PREFIX}/tv/trade?symbol=${stockName}&resolution=D&from=${from}&to=${to}`
    if (period) url = `${url}&period=${period}`
    return await axios.get(url)
        .then(response => {
            return response
        })
        .catch(error => {
            throw error
        })
}

export const apiStockFilter = payload => {
    return axios.get(`${API_PREFIX}/public/filter?${payload}`)
}

export const apiStockCard  = payload => {
    return axios.post(`${API_PREFIX}/card`, payload)
}

export const apiStockVerify = security_id => {
    return axios.get(`${API_PREFIX}/public/verify/${security_id}`)
}